import React from 'react';
import './BentoSquareLarge.scss';
import { cn } from '../../../utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { Item } from '../../ContentBuilder/templates/models/CTI_117.props';

export const cnBentoSquareLarge = cn('BentoSquareLarge');

export const BentoSquareLarge: React.FC<Item> = props => {
  const {
    title,
    isInverted,
    subtitle,
    color,
    picture,
    // link,
  } = props || {};

  const hasPicture = picture?.url.length > 0;

  return (
    <>
      {/* background can be a color or an image */}
      <div
        className={cnBentoSquareLarge({
          isInverted: isInverted,
          hasPicture: hasPicture,
        })}
        style={{
          background: `${color} url(${picture?.urlWebp ||
            picture?.url}) center bottom no-repeat`,
        }}
      >
        <div className={cnBentoSquareLarge('Inner')}>
          {title && (
            <Typography.Title
              as="h3"
              size="hg"
              className={cnBentoSquareLarge('Title')}
            >
              {title}
            </Typography.Title>
          )}
          {subtitle && (
            <Typography.Text
              as="span"
              size="m"
              className={cnBentoSquareLarge('Description')}
            >
              {subtitle}
            </Typography.Text>
          )}
        </div>
      </div>
    </>
  );
};
